<template>
  <div class="admission-query">
    <h2 class="title">合肥城市学院{{year}}年普本录取查询</h2>

    <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="query-form"
      @submit.native.prevent="getQueryEnroll">
      <!-- 年份（必填） -->
      <!-- <el-form-item label="年份" prop="year">
        <el-date-picker v-model="form.year" type="year" placeholder="请选择年份" value-format="yyyy" style="width: 100%" />
      </el-form-item> -->

      <!-- 姓名（必填） -->
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" />
      </el-form-item>

      <!-- 身份证（必填） -->
      <el-form-item label="身份证" prop="idNumber">
        <el-input v-model="form.idNumber" placeholder="请输入身份证号" />
      </el-form-item>

      <!-- 考生号（必填） -->
      <el-form-item label="考生号" prop="examNumber">
        <el-input v-model="form.examNumber" placeholder="请输入考生号" />
      </el-form-item>

      <!-- 动态结果提示 -->
      <div v-if="result.show" class="result-tip" :class="result.type">
        {{ result.message }}
      </div>

      <div class="btns">
        <el-button type="primary" native-type="submit">查询</el-button>
        <el-button @click="onReset">清空</el-button>
      </div>
    </el-form>

    <el-dialog title="查询结果" :visible.sync="dialogData.flag" center width="30%" :before-close="handleClose">

      <div class="dia-con" v-if="dialogData.data.isGet">
        <!-- 已录取 -->
        <div class="line line-cen">拟录取!</div>
        <div class="line">拟录取专业:<span>{{ dialogData.data.major }}</span></div>
        <div class="line">注:最终录取结果以所在生源省份考试院查询结果为准!</div>
      </div>
      <div class="dia-con" v-else>
        <div class="line">暂未查询到录取信息!</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdmissionQuery',
  data() {
    return {
      year:"2025",
      form: {
        // year: '',
        name: '',
        idNumber: '',
        examNumber: ''
      },
      // 必填校验规则
      rules: {
        // year: [
        //   { required: true, message: '请选择年份', trigger: 'change' }
        // ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        examNumber: [
          { required: true, message: '请输入考生号', trigger: 'blur' }
        ]
      },
      result: {
        show: false,
        type: '',
        message: ''
      },
      dialogData: {
        flag: false,
        data: {}
      }
    };
  },
  methods: {

    getQueryEnroll() {
      this.$request("post", "/terraceSetting/getQueryEnroll", null, (data) => {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          if (element.key == 'queryEnroll') {
            if (!element.isShow) {
              this.$message({
                message: '查询通道暂未开放,请耐心等待!',
                type: 'warning'
              });
              return
            } else {
              this.onSubmit()
            }
          }
        }
      });
    },
    // 查询按钮
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return; // 校验不通过
        let sendData = this.removeAllSpacesInObject(this.form)
        this.$set(sendData,"year",this.year)
        this.$request("post", "/bachelor/searchBachelor", sendData, (data) => {
          this.dialogData.data = data
          this.dialogData.flag = true
        });
      });
    },
    removeAllSpacesInObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key,
          typeof value === 'string' ? value.trim().replace(/\s+/g, '') : value
        ])
      );
    },

    // 模拟接口（请替换为 axios.post）
    mockQuery() {
      return new Promise((resolve) => {
        setTimeout(() => {
          const random = Math.random();
          if (random > 0.3) {
            resolve({
              data: { admitted: true, major: '计算机科学与技术' }
            });
          } else {
            resolve({ data: { admitted: false } });
          }
        }, 600);
      });
    },

    // 清空表单 + 重置结果
    onReset() {
      this.$refs.form.resetFields();
      this.result = { show: false, type: '', message: '' };
    },
    handleClose() {
      this.dialogData.flag = false
    },
  },
  mounted(){
    this.year = (new Date()).getFullYear()
  }
};
</script>

<style scoped>
.admission-query {
  max-width: 550px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}

.query-form .el-form-item {
  margin-bottom: 22px;
}

/* 必填星号为红色（Element UI 默认就是） */
.query-form .el-form-item.is-required .el-form-item__label::before {
  color: #f56c6c;
}

.result-tip {
  margin: 20px 0 30px;
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
}

.result-tip.success {
  color: #67c23a;
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
}

.result-tip.error {
  color: #f56c6c;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
}

.btns {
  display: flex;
  justify-content: space-between;
}

.dia-con {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.line {
  width: 100%;
  margin-bottom: 10px;
  font-size: 17px;
}

.line span {
  font-weight: 600;
}

.line-cen {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f31c1c;
  font-size: 25px;
  font-weight: 600;
}
</style>
